<app-upload-document
    [document_data_external]="upload_transaction"
    [beforepath]="beforepath"
    [validable_type]="validable_type"
    [objectId]="objectId"
    [beforepathCreate]="beforepathCreate"
    [section]="section"></app-upload-document>
